<template>
  <div v-if="cartHighDemandMessage && showMessage" class="bg-lighter-gray px-4 py-6 flex">
    <InfoIcon class="inline-block h-4 shrink-0 leading-0 mr-3 mt-[3px]" />
    <div class="leading-4 fluid-xs">{{ $t('cart.reservationNotAvailable') }}</div>
  </div>
</template>

<script>
import InfoIcon from '@/components/icons/InfoIcon.vue';
import { useCartStore } from '@/stores/cart';
import { useCartSettingsStore } from '@/stores/cart-settings';
import { storeToRefs } from 'pinia';

export default defineNuxtComponent({
  components: {
    InfoIcon,
  },

  setup() {
    const cartStore = useCartStore();
    const cartSettingsStore = useCartSettingsStore();

    const { lineItems } = storeToRefs(cartStore);
    const { highDemandProducts, cartHighDemandMessage } = storeToRefs(cartSettingsStore);

    return {
      lineItems,
      highDemandProducts,
      cartHighDemandMessage,
    };
  },

  computed: {
    showMessage() {
      return this.lineItems.some((item) => this.highDemandProducts.includes(item.variant.product.handle));
    },
  },
});
</script>
